import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { "format-key": "0" }
const _hoisted_2 = { "format-key": "1" }
const _hoisted_3 = { "format-key": "2" }
const _hoisted_4 = {
  key: 1,
  class: "_ov-xa"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "_flex _ai-c _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_localize = _resolveComponent("localize")
  const _component_grid_table_cell = _resolveComponent("grid-table-cell")
  const _component_grid_table_row = _resolveComponent("grid-table-row")
  const _component_grid_table = _resolveComponent("grid-table")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: _ctx.Resources.BackerCenter.GiftCardHistoryModalTitle,
    icon: "list",
    width: "wide",
    "show-action-close": true,
    "is-visible": $data.isVisible,
    "is-processing": _ctx.isProcessing,
    onActionClose: $options.close,
    "data-qa": "gift-card-history-modal"
  }, {
    default: _withCtx(() => [
      ($options.displayGiftCard)
        ? (_openBlock(), _createBlock(_component_localize, {
            key: 0,
            tag: "p",
            class: "_mt-0 _mb-3 _tc--base",
            resource: $options.descriptionResource,
            "data-qa": "gift-card-history-modal:Description"
          }, {
            default: _withCtx(() => [
              _createElementVNode("strong", _hoisted_1, _toDisplayString($options.giftCardName), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_2, [
                ($options.displayGiftCard.publicNote)
                  ? (_openBlock(), _createBlock(_component_tooltip, {
                      key: 0,
                      class: "_ml-1",
                      "icon-name": "circle-info",
                      "vertical-position": "down",
                      position: "left",
                      "data-qa": "gift-card-history-modal:GiftCardInfo"
                    }, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.displayGiftCard.publicNote), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("strong", _hoisted_3, _toDisplayString($options.giftCardContextName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"]))
        : _createCommentVNode("v-if", true),
      ($data.history)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_grid_table, {
              class: "gfu-gift-card-history__table",
              "data-qa": "gift-card-history-modal:History"
            }, {
              head: _withCtx(() => [
                _createVNode(_component_grid_table_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_grid_table_cell, { width: 20 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.GiftCardHistoryDateTableHeader), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_grid_table_cell, { width: 25 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.GiftCardHistoryRelatedPledgeIDTableHeader), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_grid_table_cell, { width: 20 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.GiftCardHistoryOperationTableHeader), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_grid_table_cell, {
                      width: 15,
                      "text-align": "right"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.GiftCardHistoryOperationValueTableHeader), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_grid_table_cell, {
                      width: 20,
                      "text-align": "right"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.GiftCardHistoryBalanceAfterOperationTableHeader), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedHistoryEntries, (entry) => {
                  return (_openBlock(), _createBlock(_component_grid_table_row, {
                    key: entry.key,
                    "is-short": true,
                    "data-qa": `gift-card-history-rows:${entry.key}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_grid_table_cell, {
                        width: 20,
                        "data-qa": "gift-card-history-row:Date"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$format(entry.date)), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_grid_table_cell, {
                        width: 25,
                        "data-qa": "gift-card-history-row:RelatedPledgeID"
                      }, {
                        default: _withCtx(() => [
                          (entry.hasRelatedPledge)
                            ? _renderSlot(_ctx.$slots, "related-pledge", {
                                key: 0,
                                entry: entry
                              }, () => [
                                _createTextVNode(_toDisplayString(entry.relatedPledgeID), 1 /* TEXT */)
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_grid_table_cell, {
                        width: 20,
                        "data-qa": "gift-card-history-row:Operation"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("span", null, _toDisplayString($options.operationName(entry.operationType)), 1 /* TEXT */),
                            (entry.hasRevocationReason)
                              ? (_openBlock(), _createBlock(_component_tooltip, {
                                  key: 0,
                                  "icon-name": "circle-info",
                                  "vertical-position": "down",
                                  position: "left",
                                  "data-qa": "gift-card-history-row:RevocationReason"
                                }, {
                                  content: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(entry.revocationReason), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_grid_table_cell, {
                        width: 15,
                        "text-align": "right",
                        "data-qa": "gift-card-history-row:OperationValue"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($options.formatOperationValue(entry)), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */),
                      _createVNode(_component_grid_table_cell, {
                        width: 20,
                        "text-align": "right",
                        "data-qa": "gift-card-history-row:BalanceAfterOperation"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($options.formatCurrency(entry.balanceAfterOperation)), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-qa"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 3 /* FORWARDED */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title", "is-visible", "is-processing", "onActionClose"]))
}